export interface AgentStatusColors {
  color: string;
  bgcolor: string;
  border: string;
}

export const statusLabelMap: Record<string, string> = {
  Active: 'Active',
  Inactive: 'Inactive',
  Pending: 'Pending',
};

export const getAgentStatusColor = (status: string, isDarkMode: boolean): AgentStatusColors => {
  const statusColors: Record<string, AgentStatusColors> = {
    Pending: {
      color: '#D4A017',
      bgcolor: isDarkMode ? 'rgba(212, 160, 23, 0.15)' : '#FEF9E7',
      border: '1.5px solid #D4A017',
    },
    Active: {
      color: '#00B66E',
      bgcolor: isDarkMode ? 'rgba(0, 182, 110, 0.15)' : '#E6F6EF',
      border: '1.5px solid #00B66E',
    },
    Inactive: {
      color: '#EF4444',
      bgcolor: isDarkMode ? 'rgba(239, 68, 68, 0.15)' : '#FEE2E2',
      border: '1.5px solid #EF4444',
    },
    Expired: {
      color: isDarkMode ? '#9CA3AF' : '#888',
      bgcolor: isDarkMode ? 'rgba(156, 163, 175, 0.15)' : '#F5F5F5',
      border: isDarkMode ? '1.5px solid rgba(156, 163, 175, 0.3)' : '1.5px solid #888',
    },
  };

  return (
    statusColors[status] || {
      color: isDarkMode ? '#9CA3AF' : '#6C757D',
      bgcolor: isDarkMode ? 'rgba(156, 163, 175, 0.15)' : '#F8F9FA',
      border: isDarkMode ? '1.5px solid rgba(156, 163, 175, 0.3)' : '1px solid #6C757D',
    }
  );
};
